const DAY2_PLACEHOLDER = '__DAY2__';

/**
 * Convert date-fns unicode tokens (yyyy / dd / d) to dayjs/moment tokens (YYYY / DD / D).
 * This repo uses i18n date formats in both date-fns and dayjs contexts.
 */
export const toDayjsDateFormat = (unicodeFormat: string) => {
  if (!unicodeFormat) return unicodeFormat;

  let result = unicodeFormat;

  // Year
  result = result.replaceAll('yyyy', 'YYYY');
  result = result.replaceAll('yy', 'YY');

  // Day of month (avoid touching "dd" twice)
  result = result.replaceAll('dd', DAY2_PLACEHOLDER);
  result = result.replaceAll('d', 'D');
  result = result.replaceAll(DAY2_PLACEHOLDER, 'DD');

  return result;
};
